export default __webpack_public_path__ + "static/CharterITCW05-BoldItalic-b1fc911a5cf0ce389e09292aa49d6655.woff";